<template>
  <Modal
    :show="show"
    :title="`Productos Similares a ${product.Nombre}`"
    @close="emit('close')"
  >
    <div class="space-y-6">
      <!-- Lista de productos similares -->
      <div class="border rounded-lg overflow-hidden">
        <table class="table-elegant w-full">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Laboratorio</th>
              <th>Precio Par</th>
              <th>Precio Unidad</th>
              <th>Tiempo de Demora</th>
            </tr>
          </thead>
          <tbody>
            <!-- Producto principal -->
            <tr class="bg-indigo-50">
              <td class="font-medium">{{ product.Nombre }}</td>
              <td>{{ product.laboratories[0]?.laboratory.Nombre }}</td>
              <td class="font-medium text-indigo-600">
                ${{ calculatePrice(product).toLocaleString() }}
              </td>
              <td class="font-medium text-indigo-600">
                ${{ Math.round(calculatePrice(product) / 2).toLocaleString() }}
              </td>
              <td>{{ product.laboratories[0]?.details.TiempoDeDemora }}</td>
            </tr>
            <!-- Productos similares -->
            <tr v-for="similarProduct in similarProducts" :key="similarProduct.id">
              <td class="font-medium">{{ similarProduct.Nombre }}</td>
              <td>{{ similarProduct.laboratories[0]?.laboratory.Nombre }}</td>
              <td class="font-medium text-indigo-600">
                ${{ calculatePrice(similarProduct).toLocaleString() }}
              </td>
              <td class="font-medium text-indigo-600">
                ${{ Math.round(calculatePrice(similarProduct) / 2).toLocaleString() }}
              </td>
              <td>{{ similarProduct.laboratories[0]?.details.TiempoDeDemora }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Botón de cerrar -->
      <div class="flex justify-end">
        <button
          @click="emit('close')"
          class="px-4 py-2 text-slate-600 hover:text-slate-800"
        >
          Cerrar
        </button>
      </div>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { ProductWithDetails } from '../../types';
import Modal from '../Modal.vue';

const props = defineProps<{
  show: boolean;
  product: ProductWithDetails;
  allProducts: ProductWithDetails[];
}>();

const emit = defineEmits<{
  'close': [];
}>();

// Obtener productos similares
const similarProducts = computed(() => {
  if (!props.product.similarProducts?.length) return [];
  
  return props.allProducts.filter(p => 
    props.product.similarProducts?.includes(p.id!)
  );
});

// Calcular precio de venta
const calculatePrice = (product: ProductWithDetails) => {
  const lab = product.laboratories[0];
  if (!lab) return 0;
  return Math.round(lab.details.PrecioDeCosto * product.Factor);
};
</script>